import { Attributes } from '@/entities/page.attributes';
import Organization from '@/entities/organization';
import { StorageItems } from '@/entities/storage.items';
import PageContext from '@/entities/page..context';
import { Modal } from '@/entities/modal';
import { DEVICE } from '@/entities/device';
import { WidgetsInfo } from '@/entities/widget.info';

export class AppState {
  storageItems: StorageItems = new StorageItems();
  pageAttributesMap: Map<number, Attributes> = new Map<number, Attributes>();
  userOrganizationList: Array<Organization> = new Array<Organization>();
  messages: Map<string, string> = new Map<string, string>();
  pageContext: PageContext = new PageContext();
  apiEndpoints: any = {};
  widgetsInfo: WidgetsInfo = {};
  isMobileView: boolean = false;
  isTouchScreen: boolean = false;
  modal: Modal = {};
  languageCode: string = 'en';
  device: Array<DEVICE> = [];
  loginJstate: string = '';
}
